import Services from "../services/Services";
import StringHelper from "../helpers/StringHelper";
import Usuario from "./Usuario";
import DAO from "../DAO/DAO";
import Colaborador from "./Colaborador";
import { setPermissions } from "../middlewares/permissions_control/permissions";
import Perfil from "./Perfil";
// import Usuario from "./Usuario";
// import DateHelper from "../helpers/DateHelper";

export default class Empresa {
	pk;
	cnpj;
	nome;
	nomeFantasia;
	telefone;
	email;
	logradouro;
	numero;
	complemento;
	bairro;
	cep;
	cidade;
	estado;
	perfis;
	criadoEm;
	bloqueada;
	quantidadeColaborador;
	quantidadePrazo;


	constructor({
		pk,
		cnpj,
		nome,
		nomeFantasia,
		telefone,
		email,
		logradouro,
		numero,
		complemento,
		bairro,
		cep,
		cidade,
		estado,
		perfis,
		criadoEm,
		bloqueada,
		quantidadeColaborador,
		quantidadePrazo
	}) {
		this.pk = pk;
		this.cnpj = cnpj;
		this.nome = nome;
		this.nomeFantasia = nomeFantasia;
		this.telefone = telefone;
		this.email = email;
		this.logradouro = logradouro;
		this.numero = numero;
		this.complemento = complemento;
		this.bairro = bairro;
		this.cep = cep;
		this.cidade = cidade;
		this.estado = estado;
		this.perfis = perfis;
		this.criadoEm = criadoEm;
		this.bloqueada = bloqueada;
		this.quantidadeColaborador = quantidadeColaborador;
		this.quantidadePrazo = quantidadePrazo;
	}

	static setEmpresa(empresa) {
		DAO.user.setProperty("empresa", empresa);
	}

	static entrarEmpresa(empresa) {
		try {
			Empresa.setEmpresa(empresa);
			Colaborador.setColaboradorPorEmpresa(empresa);
		} catch (error) {
			return null;
		}
	}

	static async getEmpresa(empresaPk) {
		let empresa = await Services.EmpresaService.empresa(empresaPk);

		if (empresa) {
			return Empresa.fromMap(empresa);
		}

		return null;
	}

	static async getEmpresas(params) {
		const empresaResponse = await Services.EmpresaService.empresas(params);

		if (empresaResponse.results) {
			return {
				empresas: Empresa.fromListMap(empresaResponse.results),
				totalEmpresas: empresaResponse.count
			};
		}
		return [];
	}

	static async criar(empresa) {

		const cnpj = StringHelper.alphanumericOnly(empresa.cnpj);
		const telefone = StringHelper.alphanumericOnly(empresa.telefone);
		const cep = StringHelper.alphanumericOnly(empresa.cep);

		await Services.EmpresaService.criarEmpresa({
			...empresa,
			fantasia: empresa.nomeFantasia,
			cnpj,
			cep,
			telefone
		});
	}

	static async editar(empresa) {

		const cnpj = StringHelper.alphanumericOnly(empresa.cnpj);
		const telefone = StringHelper.alphanumericOnly(empresa.telefone);
		const cep = StringHelper.alphanumericOnly(empresa.cep);

		await Services.EmpresaService.editarEmpresa(
			empresa.pk,
			{
				...empresa,
				fantasia: empresa.nomeFantasia,
				cnpj,
				cep,
				telefone
			}
		);
	}

	static async enviarAnexo(empresaPk, anexoFile, onProgress) {

		const formData = new FormData();

		formData.set("nome_original", anexoFile.name);
		formData.set("arquivo", anexoFile);

		const anexoResponse = await Services.EmpresaService.enviarAnexo(
			empresaPk,
			formData,
			onProgress,
		);

		return anexoResponse;
	}

	static async excluirAnexo(empresaPk, anexoPk) {
		return await Services.EmpresaService.excluirAnexo(
			empresaPk,
			anexoPk,
		);
	}

	static async getGerenciaveis(empresaPk, perfilPk, params) {
		const gerenciaveisResponse = await Services.EmpresaService.gerenciaveis(empresaPk, perfilPk, params);

		if (gerenciaveisResponse.results) {
			return {
				gerenciaveis: Usuario.fromListMap(gerenciaveisResponse.results),
				totalGerenciaveis: gerenciaveisResponse.count
			};
		}
		return [];
	}

	static setPermissoes() {
		const permissoes = {};
		const usuarioAutenticado = Usuario.getUsuarioAutenticado();

		if (usuarioAutenticado.isSuperUser) {
			permissoes["autenticado"] = {
				superuser: true
			}
		} else {
			permissoes["autenticado"] = {
				autenticado: true
			}
		}

		setPermissions(permissoes);
	}

	static fromMap(map) {

		if (!map) {
			return map;
		}

		if (map.perfis) {
			map.perfis = map.perfis.map(perfil => {
				return Perfil.fromMap(perfil);
			});
		}

		return new Empresa({
			...map,
			nomeFantasia: map.fantasia,
			quantidadeColaborador: map.qtd_colaboradores,
			quantidadePrazo: map.qtd_prazos,
			criadoEm: map.created_at,
		});
	}

	static fromListMap(mapList) {
		return mapList.map(map => {

			return Empresa.fromMap(map);
		})
	}
}
